module.exports = __webpack_public_path__ + "static/media/testimonial_img2.6450a06a.png";